#import "@/apollo/fragments/Campaign.gql"

mutation UpdateCampaignMutation($campaignId: ID!, $campaign: InputCampaign!) {
    updateCampaign(campaignId: $campaignId, campaign: $campaign) {
        ...Campaign
        client {
            _id
            id
        }
    }
}
